<script setup>
import {mapErrors} from '@/utilities';
import {useForm, usePage} from '@inertiajs/vue3';
import {computed, inject, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import Button from '@/Components/Button/Button.vue';

const route = inject('route');
const {t} = useI18n();


const form = useForm({
    name: '',
    email: '',
    phone: '',
    message: '',
    subject: '',
    terms: false,
    url: usePage().props.route.current,
});

const termsAndConditions = computed(() => '/storage/' + usePage().props.template_options.global.terms_and_conditions);
const submittedForm = ref(false);

const sendForm = () => {
    form.post(route('public.contact-form'), {
        preserveState: true,
        preserveScroll: true,
        onSuccess: () => submittedForm.value = true,
        onError: (errors) => form.errors = mapErrors(errors),
    });
};
</script>

<template>
    <div>
        <div v-if="submittedForm">
            <h2 class="mb-2 text-2xl">
                {{ t('Thank you for your message!') }}
            </h2>
            <p class="text-center">
                {{ t('We have received your message. One of our employees will contact you as soon as possible.') }}
            </p>
        </div>
        <form
            v-else
        >
            <FormKit
                v-model="form.name"
                :errors="form.errors.name"
                :label="$t('Name *')"
                :value="form.name"
                name="name"
                type="text"
                validate="required"
            />

            <FormKit
                v-model="form.email"
                :errors="form.errors.email"
                :label="$t('E-mail *')"
                name="email"
                type="email"
                validate="required"
            />

            <FormKit
                v-model="form.phone"
                :errors="form.errors.phone"
                :label="$t('Phone *')"
                :value="form.phone"
                name="phone_number"
                type="text"
            />

            <FormKit
                v-model="form.subject"
                :errors="form.errors.subject"
                :label="$t('Subject *')"
                :value="form.subject"
                name="subject"
                type="text"
            />

            <FormKit
                v-model="form.message"
                :errors="form.errors.message"
                :label="$t('Message *')"
                :value="form.message"
                name="message"
                type="textarea"
            />

            <div class="flex">
                <FormKit
                    v-model="form.terms"
                    :classes="{
                        outer: '$reset :w-5 flex flex-col gap-2 items-center justify-center',

                    }"
                    :errors="form.errors.terms"
                    name="terms"
                    type="checkbox"
                />

                <div class="mt-1 flex gap-1 font-bold">
                    <p>{{ t('I agree with the') }}</p>
                    <a
                        :href="termsAndConditions"
                        class="underline hover:text-primary "
                    >{{
                        t('terms and conditions')
                    }}</a>
                </div>
            </div>

            <div class="flex flex-col items-end">
                <p class="text-xs">
                    {{ t('*Required fields') }}
                </p>

                <Button
                    :form="form"
                    :label="t('Submit')"
                    class="mt-6 w-auto "
                    type="button"
                    @click="sendForm"
                />
            </div>
        </form>
    </div>
</template>
